/**
 * This class is used to communicate quote contact information to/from the web service.
 */
export class QuoteContact {

	Name: string;

	Address1: string;

	Address2: string;

	City: string;

	State: string;

	PostalCode: string;

	ContactName: string;

	PhoneNumber: string;

	AddressIdentifier: string;

	AddressName: string;

	SaveAddress: boolean;

	Changed: boolean;

}